import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import Skeleton from "primevue/skeleton";

export default /*#__PURE__*/_defineComponent({
  __name: 'SceletonInput',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_unref(Skeleton), {
        key: 0,
        height: "2.2rem",
        class: "mb-2"
      }))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})